const state = {
  sessionId: undefined,
  token: undefined,
  phone: undefined,
  marketplaceInfo: undefined,
  flagsData: undefined,
  tncUrl: undefined
};
export default state;
